import type { RoleId } from '../role';
import type { Command } from './commands';
import { getRouteKind } from './route-classification';
import { isRouteAllowedForRole } from './route-roles';

/** Match the existing shell's route classification and active-role guard. */
export function isCommandAvailable(command: Command, authenticated: boolean, activeRoleId: RoleId | null): boolean {
  if (!command.route) return !!command.action;
  const segments = command.route.replace(/^\/+/, '').split('/');
  const routeId = segments[0], subPath = segments.slice(1).join('/');
  if (getRouteKind(routeId, subPath) !== 'WORKSPACE') return true;
  return authenticated && isRouteAllowedForRole(routeId, segments.slice(0, 2).join('/'), activeRoleId);
}
